// import React, { useEffect } from 'react'
// import Navbar from '../HomePage/Navbar.js'
// import ContactusBanner from './ContactusBanner.js'
// import Footer from '../HomePage/Footer.js'
// import ContactUsForm from './ContactUsForm.js'
// import ContactusDetails from './ContactusDetails.js'
// import FAQs from './FAQs.js'
// import StayConnected from '../AboutUs/StayConnected.js'
// import VolunteerFormPopup from '../volunteerForm/VolunteerFormPopup.js'
// import { useDispatch } from 'react-redux'
// import { openVolunteerPopup } from '../features/volunteerPopupSlice.js'
// import HalfBanner from '../HomePage/HalfBanner.js'
// import StayConnectedSocialIcons from '../Events/StayConnectedSocialIcons.js'
// export default function ContactUsMainPage() {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const shown = sessionStorage.getItem("volunteerPopupShown");
//     console.log("shown", shown)
//     if (!shown) {

//       const timer = setTimeout(() => {
//         dispatch(openVolunteerPopup());
//         sessionStorage.setItem("volunteerPopupShown", "true");
//       }, 3000);

//       return () => clearTimeout(timer);
//     }
//   }, [dispatch]);
//   return (
//     <div>
//       <VolunteerFormPopup />
//       {/* <Navbar /> */}
//       <ContactusBanner />
//       <ContactUsForm />
//       <ContactusDetails />
//       {/* <FAQs /> */}
//       <StayConnectedSocialIcons />
//       <Footer />
//     </div>
//   )
// }

import React, { useEffect, useState } from 'react'
import Navbar from '../HomePage/Navbar.js'
import ContactusBanner from './ContactusBanner.js'
import Footer from '../HomePage/Footer.js'
import ContactUsForm from './ContactUsForm.js'
import ContactusDetails from './ContactusDetails.js'
import FAQs from './FAQs.js'
import StayConnected from '../AboutUs/StayConnected.js'
import VolunteerFormPopup from '../volunteerForm/VolunteerFormPopup.js'
import { useDispatch } from 'react-redux'
import { openVolunteerPopup } from '../features/volunteerPopupSlice.js'
import HalfBanner from '../HomePage/HalfBanner.js'
import StayConnectedSocialIcons from '../Events/StayConnectedSocialIcons.js'

export default function ContactUsMainPage() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('form'); // 'form' or 'details'

  // useEffect(() => {
  //   const shown = sessionStorage.getItem("volunteerPopupShown");
  //   console.log("shown", shown)
  //   if (!shown) {
  //     const timer = setTimeout(() => {
  //       dispatch(openVolunteerPopup());
  //       sessionStorage.setItem("volunteerPopupShown", "true");
  //     }, 3000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [dispatch]);

const title = "Connect With Us"
const subTitle = "We welcome your inquiry and your presence. Whether you are looking to understand our mission or ready to partner with us in creating a lasting impact, join our journey of grace as we restore the promise of a dignified future"

  return (
    <div>
      <VolunteerFormPopup />
      {/* <Navbar /> */}
      <ContactusBanner  title = {title} description = {subTitle}/>
      
      {/* Tab Container with Buttons */}
       <div className='customcontainer'>
      <div className="tab-btn-container">
         <button 
          type="button"
          className={`tab-btn ${activeTab === 'form' ? 'active' : ''}`}
          onClick={() => setActiveTab('form')}
        >
          Contact Form
        </button>
        <button 
          type="button"
          className={`tab-btn ${activeTab === 'details' ? 'active' : ''}`}
          onClick={() => setActiveTab('details')}
        >
          Contact Details
        </button>
       </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content-wrapper" style={{marginBottom:"6rem"}}>
        {activeTab === 'form' ? <ContactUsForm /> : <ContactusDetails />}
      </div>
      
      <Footer />
    </div>
  )
}